module.exports = __webpack_public_path__ + "static/media/m_3.60097a43.svg";